<template>
  <div class="container-fluid py-4" v-loading="loading">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-sm border-0 border-radius-xl">
          <div class="card-header pb-0 p-4 d-flex align-items-center gap-3">
            <div class="icon-shape bg-gradient-info text-white rounded-circle shadow-info d-flex align-items-center justify-content-center" style="width: 44px; height: 44px;">
              <i class="fas fa-key"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bolder">Şifrəni Dəyiş</h5>
              <p class="text-xs text-muted mb-0">Hesabınızın təhlükəsizliyi üçün yeni şifrə təyin edin</p>
            </div>
          </div>

          <div class="card-body p-4">
            <!-- Success / Error Alert -->
            <div v-if="alertMessage" :class="`alert alert-${alertType} d-flex align-items-center gap-2 p-3 mb-4 border-radius-lg text-sm`" role="alert">
              <i :class="alertType === 'success' ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-triangle-fill'"></i>
              <div>{{ alertMessage }}</div>
            </div>

            <form @submit.prevent="handleChangePassword" role="form">
              <!-- Old Password -->
              <div class="form-group mb-3">
                <label class="form-label text-xs font-weight-bold">Köhnə şifrə</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-shield-lock"></i></span>
                  <input
                    v-model="oldPassword"
                    type="password"
                    class="form-control"
                    placeholder="Mövcud şifrənizi daxil edin"
                    required
                  />
                </div>
              </div>

              <!-- New Password -->
              <div class="form-group mb-3">
                <label class="form-label text-xs font-weight-bold">Yeni şifrə</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-key"></i></span>
                  <input
                    v-model="newPassword"
                    type="password"
                    class="form-control"
                    placeholder="Yeni şifrəni daxil edin"
                    required
                  />
                </div>
              </div>

              <!-- Confirm Password -->
              <div class="form-group mb-4">
                <label class="form-label text-xs font-weight-bold">Yeni şifrəni təkrarlayın</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-check2-circle"></i></span>
                  <input
                    v-model="confirmPassword"
                    type="password"
                    class="form-control"
                    placeholder="Yeni şifrəni təkrar daxil edin"
                    required
                  />
                </div>
              </div>

              <!-- Action buttons -->
              <div class="d-flex justify-content-end gap-2">
                <router-link to="/home" class="btn btn-light px-4 mb-0">
                  Ləğv et
                </router-link>
                <button type="submit" class="btn bg-gradient-info px-4 mb-0" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Yadda saxla
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  name: "ChangePassword",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      alertMessage: null,
      alertType: "danger",
      loading: false,
    };
  },
  methods: {
    handleChangePassword() {
      this.alertMessage = null;

      if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
        this.alertType = "danger";
        this.alertMessage = "Bütün sahələri doldurun.";
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.alertType = "danger";
        this.alertMessage = "Yeni şifrə və təkrar şifrə eyni olmalıdır!";
        return;
      }

      if (this.newPassword.length < 6) {
        this.alertType = "danger";
        this.alertMessage = "Yeni şifrə ən azı 6 simvoldan ibarət olmalıdır.";
        return;
      }

      this.loading = true;

      setTimeout(() => {
        this.loading = false;
        this.alertType = "success";
        this.alertMessage = "Şifrəniz uğurla dəyişdirildi! Yenidən daxil olun.";

        setTimeout(() => {
          try {
            window.localStorage.setItem(
              "jwt",
              CryptoJS.AES.encrypt(JSON.stringify("none"), "secret_key").toString()
            );
          } catch (e) {
            // ignore
          }
          this.$router.push("/signIn");
        }, 1200);
      }, 600);
    },
  },
};
</script>
